export default __webpack_public_path__ + "static/media/ClassonThumbnailBlack3.69c1cff4.png";